export const FETCHING_MAIL_GROUP_LIST = '@@toyota/FETCHING_MAIL_GROUP_LIST';
export const FETCHED_MAIL_GROUP_LIST = '@@toyota/FETCHED_MAIL_GROUP_LIST';
export const FETCHED_MAIL_GROUP_LIST_FAILED =
  '@@toyota/FETCHED_MAIL_GROUP_LIST_FAILED';

export const FETCHING_INTERNAL_USERS_LIST_BY_GROUP = '@@toyota/FETCHING_INTERNAL_USERS_LIST_BY_GROUP';
export const FETCHED_INTERNAL_USERS_LIST_BY_GROUP = '@@toyota/FETCHED_INTERNAL_USERS_LIST_BY_GROUP';
export const FETCHED_INTERNAL_USERS_LIST_BY_GROUP_FAILED =
  '@@toyota/FETCHED_INTERNAL_USERS_LIST_BY_GROUP_FAILED';

export const FETCHING_MAIL_GROUP_INFO = '@@toyota/FETCHING_MAIL_GROUP_INFO';
export const FETCHED_MAIL_GROUP_INFO = '@@toyota/FETCHED_MAIL_GROUP_INFO';
export const FETCHED_MAIL_GROUP_INFO_FAILED = '@@toyota/FETCHED_MAIL_GROUP_INFO_FAILED';

export const FETCHING_EXTERNAL_USERS_LIST_BY_GROUP = '@@toyota/FETCHING_INTERNAL_USERS_LIST_BY_GROUP';
export const FETCHED_EXTERNAL_USERS_LIST_BY_GROUP = '@@toyota/FETCHED_EXTERNAL_USERS_LIST_BY_GROUP';
export const FETCHED_EXTERNAL_USERS_LIST_BY_GROUP_FAILED = '@@toyota/FETCHED_EXTERNAL_USERS_LIST_BY_GROUP_FAILED';

export const FETCHING_MAIL_GROUP_INFO_BY_GROUP = '@@toyota/FETCHING_MAIL_GROUP_INFO_BY_GROUP';
export const FETCHED_MAIL_GROUP_INFO_BY_GROUP = '@@toyota/FETCHED_MAIL_GROUP_INFO_BY_GROUP';
export const FETCHED_MAIL_GROUP_INFO_BY_GROUP_FAILED = '@@toyota/FETCHED_MAIL_GROUP_INFO_BY_GROUP_FAILED';

export const CLEAR_INTERNAL_USERS_LIST = '@@toyota/CLEAR_INTERNAL_USERS_LIST';
export const CLEAR_EXTERNAL_USERS_LIST = '@@toyota/CLEAR_EXTERNAL_USERS_LIST';

export const ADDING_NEW_GROUP_INFO = '@@toyota/ADDING_NEW_GROUP_INFO';
export const ADDED_NEW_GROUP_INFO = '@@toyota/ADDED_NEW_GROUP_INFO';
export const ADDED_NEW_GROUP_INFO_FAILED = '@@toyota/ADDED_NEW_GROUP_INFO_FAILED';

export const UPDATING_NEW_GROUP_INFO = '@@toyota/UPDATING_NEW_GROUP_INFO';
export const UPDATED_NEW_GROUP_INFO = '@@toyota/UPDATED_NEW_GROUP_INFO';
export const UPDATED_NEW_GROUP_INFO_FAILED = '@@toyota/UPDATED_NEW_GROUP_INFO_FAILED';

export const SET_MAIL_GROUP_FIELD = '@@toyota/SET_MAIL_GROUP_FIELD';

export const DELETING_EXTERNAL_USER_BY_GROUP =
  '@@toyota/DELETING_EXTERNAL_USER_BY_GROUP';
export const DELETED_EXTERNAL_USER_BY_GROUP =
  '@@toyota/DELETED_EXTERNAL_USER_BY_GROUP';
export const DELETED_EXTERNAL_USER_BY_GROUP_FAILED =
  '@@toyota/DELETED_EXTERNAL_USER_BY_GROUP_FAILED';

export const DELETING_INTERNAL_USER_BY_GROUP =
  '@@toyota/DELETING_INTERNAL_USER_BY_GROUP';
export const DELETED_INTERNAL_USER_BY_GROUP =
  '@@toyota/DELETED_INTERNAL_USER_BY_GROUP';
export const DELETED_INTERNAL_USER_BY_GROUP_FAILED =
  '@@toyota/DELETED_INTERNAL_USER_BY_GROUP_FAILED';

export const ADDING_NEW_EXTERNAL_USER_BY_GROUP =
  '@@toyota/ADDING_NEW_EXTERNAL_USER_BY_GROUP';
export const ADDED_NEW_EXTERNAL_USER_BY_GROUP =
  '@@toyota/ADDED_NEW_EXTERNAL_USER_BY_GROUP';
export const ADDED_NEW_EXTERNAL_USER_BY_GROUP_FAILED =
  '@@toyota/ADDED_NEW_EXTERNAL_USER_BY_GROUP_FAILED';

export const ADDING_NEW_INTERNAL_USER_BY_GROUP =
  '@@toyota/ADDING_NEW_INTERNAL_USER_BY_GROUP';
export const ADDED_NEW_INTERNAL_USER_BY_GROUP =
  '@@toyota/ADDED_NEW_INTERNAL_USER_BY_GROUP';
export const ADDED_NEW_INTERNAL_USER_BY_GROUP_FAILED =
  '@@toyota/ADDED_NEW_INTERNAL_USER_BY_GROUP_FAILED';

export const UPDATING_ALL_INTERNAL_USER_BY_GROUP =
  '@@toyota/UPDATING_ALL_INTERNAL_USER_BY_GROUP';
export const UPDATED_ALL_INTERNAL_USER_BY_GROUP =
  '@@toyota/UPDATED_ALL_INTERNAL_USER_BY_GROUP';
export const UPDATED_ALL_INTERNAL_USER_BY_GROUP_FAILED =
  '@@toyota/UPDATED_ALL_INTERNAL_USER_BY_GROUP_FAILED';

export const UPDATING_ALL_EXTERNAL_USER_BY_GROUP =
  '@@toyota/UPDATING_ALL_EXTERNAL_USER_BY_GROUP';
export const UPDATED_ALL_EXTERNAL_USER_BY_GROUP =
  '@@toyota/UPDATED_EXTERNAL_USER_BY_GROUP';
export const UPDATED_ALL_EXTERNAL_USER_BY_GROUP_FAILED =
  '@@toyota/UPDATED_ALL_EXTERNAL_USER_BY_GROUP_FAILED';

export const UPDATE_INTERNAL_USER_LIST = '@@toyota/UPDATE_INTERNAL_USER_LIST';
export const UPDATE_EXTERNAL_USER_LIST = '@@toyota/UPDATE_EXTERNAL_USER_LIST';
